/* ============================================================
   AURORE — assets/aurore-header.js  v7 FIXED

   Bug fixes v7:
   1. MEGA MENU (position:fixed): The mega panel lives in the DOM
      inside <li> but is painted outside it (fixed). Mouse leaving
      the <li> to reach the mega triggered mouseleave + close.
      Fix: attach mouseenter/mouseleave listeners directly on the
      DOCUMENT-level mega panel element, not via li descendant
      hover. Use a shared activeMenu ref + clearable timer.
   2. updateHeaderHeight() sets --aur-header-h on :root so the
      fixed mega menu top aligns correctly.
   3. All v5 fixes retained (mobile nav, search, cart, ESC, etc.)
   ============================================================ */
(function () {
  'use strict';

  /* ── helpers ── */
  function qs(s, ctx)  { return (ctx || document).querySelector(s); }
  function qsa(s, ctx) { return Array.from((ctx || document).querySelectorAll(s)); }

  function money(cents) {
    var cur = 'USD';
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        cur = window.Shopify.currency.active;
      }
    } catch(e) {}
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency', currency: cur, minimumFractionDigits: 2
      }).format(cents / 100);
    } catch(e) { return '$' + (cents / 100).toFixed(2); }
  }

  function esc(s) {
    return String(s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function parseMoneyToCents(value) {
    if (typeof value === 'number') return Math.round(value * 100);
    var cleaned = String(value || '').replace(/[^0-9.]/g, '');
    return cleaned ? Math.round(parseFloat(cleaned) * 100) : 0;
  }

  function formatCartPropertyName(key) {
    return String(key || '').replace(/^_+/, '').replace(/_/g, ' ').trim();
  }

  function isShippingCartProperty(key) {
    var cleanKey = formatCartPropertyName(key).toLowerCase();
    return cleanKey.indexOf('ships by') !== -1
      || cleanKey.indexOf('ship by') !== -1
      || cleanKey.indexOf('shipping date') !== -1
      || cleanKey.indexOf('delivery date') !== -1;
  }

  function shouldShowCartProperty(key, value) {
    if (value === null || value === undefined || value === '') return false;
    var rawKey = String(key || '');
    var cleanKey = formatCartPropertyName(rawKey).toLowerCase();
    if (cleanKey === 'time notification') return false;
    if (rawKey.charAt(0) !== '_') return true;
    return isShippingCartProperty(key);
  }

  function cartPropertyHtml(key, value) {
    if (!shouldShowCartProperty(key, value)) return '';
    var label = formatCartPropertyName(key);
    var valueText = String(value);
    var valueHtml = valueText.indexOf('/uploads/') !== -1
      ? '<a href="' + esc(valueText) + '" target="_blank" rel="noopener">' + esc(valueText.split('/').pop()) + '</a>'
      : '<span>' + esc(valueText) + '</span>';
    return '<div class="aur-ci-variant aur-ci-property">'
      + '<span class="aur-ci-property-label">' + esc(label) + ':</span> '
      + valueHtml
      + '</div>';
  }

  var CART_RECOMMENDATION_TYPE_ORDER = ['earring', 'bracelet', 'bangle', 'pendant', 'necklace', 'charm'];
  var CART_RECOMMENDATION_EXCLUDED_TAGS = [
    'badge:sale', 'badge:new', 'badge:bestseller', 'just arrived', 'ready to ship',
    'sample sale', 'best seller', 'bestseller', 'sale', 'new'
  ];
  var CART_ESTIMATE_TAX_RATE = 0.09;
  var cartEstimate = {
    subtotal: 0,
    originalTotal: 0,
    total: 0,
    cartLevelDiscountHtml: '',
    zip: '',
    selectedShipping: 0,
    selectedRate: null,
    rates: []
  };
  var aurLastCart = null;

  function normalizeCartRecTag(tag) {
    return String(tag || '').toLowerCase().trim();
  }

  function expandCartRecommendationProduct(product) {
    if (!product || typeof product !== 'object') return null;
    if (product.id || product.url || product.title) return product;
    return {
      id: product.i,
      title: product.t,
      type: product.y,
      tags: Array.isArray(product.g) ? product.g : [],
      url: product.u,
      image: product.m,
      price: product.p,
      compareAtPrice: product.c,
      autoDiscountPercent: product.d,
      variantId: product.v
    };
  }

  function getCartRecommendationProducts() {
    var node = qs('#aurCartRecommendationData');
    if (!node) return [];
    try {
      var products = JSON.parse(node.textContent || '[]');
      return Array.isArray(products) ? products.map(expandCartRecommendationProduct).filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function cartRecStyleTags(product) {
    var tags = product && Array.isArray(product.tags) ? product.tags : [];
    var styleTags = [];
    tags.forEach(function (tag) {
      var key = normalizeCartRecTag(tag);
      if (!key || key.indexOf('badge:') !== -1 || CART_RECOMMENDATION_EXCLUDED_TAGS.indexOf(key) !== -1) return;
      if (styleTags.indexOf(key) === -1) styleTags.push(key);
      if (key === 'wave' && styleTags.indexOf('wavy') === -1) styleTags.push('wavy');
      if (key === 'wavy' && styleTags.indexOf('wave') === -1) styleTags.push('wave');
    });
    return styleTags;
  }

  function cartRecMatchesStyle(product, styleTags) {
    if (!product || !Array.isArray(product.tags) || !styleTags.length) return false;
    return product.tags.some(function (tag) {
      return styleTags.indexOf(normalizeCartRecTag(tag)) !== -1;
    });
  }

  function buildCartStyleRecommendations(cart, limit) {
    var products = getCartRecommendationProducts();
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    if (!products.length || !items.length) return [];

    var sources = items.map(function (item) {
      return products.find(function (product) { return product.id === item.product_id; }) || {
        id: item.product_id,
        type: item.product_type,
        tags: []
      };
    });
    var sourceTypes = sources.map(function (source) {
      return normalizeCartRecTag(source.type);
    }).filter(Boolean);
    var primaryType = sourceTypes[0] || '';
    var styleTags = [];
    sources.forEach(function (source) {
      cartRecStyleTags(source).forEach(function (tag) {
        if (styleTags.indexOf(tag) === -1) styleTags.push(tag);
      });
    });
    var cartProductIds = items.map(function (item) { return item.product_id; });
    var renderedIds = {};
    var results = [];

    function canUse(product, avoidCartTypes) {
      var productType = normalizeCartRecTag(product.type);
      return product
        && cartProductIds.indexOf(product.id) === -1
        && !renderedIds[product.id]
        && productType
        && (!primaryType || productType !== primaryType)
        && (!avoidCartTypes || sourceTypes.indexOf(productType) === -1);
    }

    function addProduct(product) {
      renderedIds[product.id] = true;
      results.push(product);
    }

    function addByTypeOrder(requireStyle, avoidCartTypes) {
      CART_RECOMMENDATION_TYPE_ORDER.forEach(function (targetType) {
        if (results.length >= limit || (primaryType && targetType === primaryType)) return;
        if (avoidCartTypes && sourceTypes.indexOf(targetType) !== -1) return;
        var match = products.find(function (product) {
          return canUse(product, avoidCartTypes)
            && normalizeCartRecTag(product.type) === targetType
            && (!requireStyle || cartRecMatchesStyle(product, styleTags));
        });
        if (match) addProduct(match);
      });
    }

    function addAny(requireStyle, avoidCartTypes) {
      products.forEach(function (product) {
        if (results.length >= limit) return;
        if (canUse(product, avoidCartTypes) && (!requireStyle || cartRecMatchesStyle(product, styleTags))) addProduct(product);
      });
    }

    addByTypeOrder(true, true);

    if (results.length < limit) {
      addAny(true, true);
    }

    if (results.length < limit) {
      addByTypeOrder(true, false);
    }

    if (results.length < limit) {
      addAny(true, false);
    }

    if (results.length < limit) {
      addByTypeOrder(false, true);
    }

    if (results.length < limit) {
      addAny(false, true);
    }

    if (results.length < limit) {
      addByTypeOrder(false, false);
    }

    if (results.length < limit) {
      products.forEach(function (product) {
        if (results.length >= limit) return;
        if (product && cartProductIds.indexOf(product.id) === -1 && !renderedIds[product.id]) addProduct(product);
      });
    }

    return results.slice(0, limit);
  }

  /* ================================================================
     1. HEADER HEIGHT TRACKING
     Sets --aur-header-h on :root — used by:
       • .aur-mega        (position:fixed, top: var(--aur-header-h))
       • .aur-search-panel (position:fixed, top: var(--aur-header-h))
     Called on load, resize, orientationchange, font load, and
     before opening any panel.
     ================================================================ */
  function updateHeaderHeight() {
    var root   = document.documentElement;
    var annEl  = qs('.aur-ann');
    var navEl  = qs('.aur-nav');
    var section = qs('.aurore-header-section') || qs('#aurHeaderSticky');

    var annH   = (annEl && annEl.offsetHeight) ? annEl.offsetHeight : 0;
    var navH   = (navEl && navEl.offsetHeight) ? navEl.offsetHeight : 60;
    var totalH = section ? section.offsetHeight : (annH + navH);

    root.style.setProperty('--aur-header-h', totalH + 'px');
    root.style.setProperty('--aur-ann-h',    annH   + 'px');
    root.style.setProperty('--aur-nav-h',    navH   + 'px');
  }

  updateHeaderHeight();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderHeight);
  }
  window.addEventListener('load', updateHeaderHeight);
  window.addEventListener('resize', updateHeaderHeight, { passive: true });
  window.addEventListener('resize', placeCartCapture, { passive: true });
  window.addEventListener('orientationchange', updateHeaderHeight);
  window.addEventListener('orientationchange', placeCartCapture);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderHeight);
  }
  initCartSummaryTabs();
  initCartShippingEstimate();
  placeCartCapture();


  /* ================================================================
     2. MEGA MENU — DEFINITIVE FIX v8

     THE PROBLEM:
     .aur-mega is a DOM child of <li>. The <li> is inside
     .aur-nav-links which has transform:translateX(-50%).
     CSS rule: any element with transform/filter/will-change/contain
     creates a NEW containing block for position:fixed descendants.
     So position:fixed on .aur-mega was fixed relative to
     .aur-nav-links (the transformed ancestor), NOT the viewport.
     Result: mega menu rendered offset and half-width.

     THE FIX:
     1. On init, move every .aur-mega out of the <li> and append
        it directly to <body>. Body has no transform = true viewport
        fixed positioning works correctly.
     2. Link each <li> to its detached mega via data-mega-id.
     3. Use mouseenter/mouseleave on both the <li> and the mega
        panel (since they're now separate DOM trees) with a shared
        close timer to bridge the hover gap.
     ================================================================ */
  (function () {
    var navItems = qsa('.aur-nav-links > li');
    var closeTimers = {};
    var megaMap = {};   /* id → mega element */
    var liMap   = {};   /* id → li element   */
    var idCount = 0;

    navItems.forEach(function (li) {
      var mega = qs('.aur-mega', li);
      if (!mega) return;

      /* Assign a unique ID to link li ↔ mega after detach */
      var id = 'aur-mega-' + (++idCount);
      li.setAttribute('data-mega-id', id);
      mega.setAttribute('data-mega-id', id);
      megaMap[id] = mega;
      liMap[id]   = li;

      /* ── DETACH: move mega to <body> ──
         This removes it from the transformed ancestor chain.
         position:fixed now works relative to the true viewport. */
      document.body.appendChild(mega);
    });

    /* ── Wire up hover/focus events AFTER detach ── */
    Object.keys(megaMap).forEach(function (id) {
      var mega = megaMap[id];
      var li   = liMap[id];

      function openMega() {
        clearTimeout(closeTimers[id]);

        /* Close every other open mega */
        Object.keys(megaMap).forEach(function (otherId) {
          if (otherId !== id) {
            megaMap[otherId].classList.remove('is-open');
          }
        });

        updateHeaderHeight();
        mega.classList.add('is-open');
      }

      function scheduleClose() {
        clearTimeout(closeTimers[id]);
        closeTimers[id] = setTimeout(function () {
          mega.classList.remove('is-open');
        }, 150);
      }

      /* <li> events */
      li.addEventListener('mouseenter', openMega);
      li.addEventListener('mouseleave', scheduleClose);

      /* mega panel events — now a separate DOM tree from <li> */
      mega.addEventListener('mouseenter', function () {
        clearTimeout(closeTimers[id]);
      });
      mega.addEventListener('mouseleave', scheduleClose);

      /* Keyboard */
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          mega.classList.remove('is-open');
          var link = qs('.aur-nav-link', li);
          if (link) link.focus();
        }
      });
    });

    /* Close on outside click */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.aur-nav-links') && !e.target.closest('.aur-mega')) {
        Object.keys(megaMap).forEach(function (id) {
          megaMap[id].classList.remove('is-open');
        });
      }
    });

    /* Close on scroll */
    window.addEventListener('scroll', function () {
      Object.keys(megaMap).forEach(function (id) {
        megaMap[id].classList.remove('is-open');
      });
    }, { passive: true });

  })();


  /* ================================================================
     3. ANNOUNCEMENT BAR
     Single message: show immediately, hide dots container.
     Multiple messages: rotate every 4.2s with dot nav.
     ================================================================ */
  (function () {
    var msgs     = qsa('.aur-ann-msg');
    var dotsWrap = qs('#aurAnnDots');
    if (!msgs.length) return;

    if (msgs.length === 1) {
      msgs[0].classList.add('is-active');
      if (dotsWrap) dotsWrap.style.display = 'none';
      return;
    }

    if (dotsWrap) {
      msgs.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.className = 'aur-ann-dot';
        btn.setAttribute('aria-label', 'Go to announcement ' + (i + 1));
        btn.addEventListener('click', function () { show(i); resetTimer(); });
        dotsWrap.appendChild(btn);
      });
    }

    var dots  = qsa('.aur-ann-dot');
    var cur   = 0;
    var timer = null;

    function show(idx) {
      msgs.forEach(function (m, i) {
        m.classList.remove('is-active', 'is-prev', 'is-next');
        if      (i === idx) m.classList.add('is-active');
        else if (i <  idx)  m.classList.add('is-prev');
        else                m.classList.add('is-next');
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
      cur = idx;
    }

    function advance() { show((cur + 1) % msgs.length); }

    function resetTimer() {
      clearInterval(timer);
      timer = setInterval(advance, 4200);
    }

    show(0);
    resetTimer();
  })();


  /* ================================================================
     4. STICKY NAV SHADOW
     ================================================================ */
  (function () {
    var nav  = qs('.aur-nav');
    if (!nav) return;
    var tick = false;
    function check() {
      nav.classList.toggle('is-scrolled', window.scrollY > 8);
      tick = false;
    }
    window.addEventListener('scroll', function () {
      if (!tick) { requestAnimationFrame(check); tick = true; }
    }, { passive: true });
    check();
  })();


  /* ================================================================
     5. MOBILE NAV DRAWER
     ================================================================ */
  var hamburger = qs('#aurHamburger');
  var mobNav    = qs('#aurMobNav');
  var mobClose  = qs('#aurMobClose');

  function openMob() {
    if (!mobNav) return;
    mobNav.classList.add('open');
    if (hamburger) {
      hamburger.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
    }
    document.body.classList.add('aur-no-scroll');
  }

  function closeMob() {
    if (!mobNav) return;
    mobNav.classList.remove('open');
    if (hamburger) {
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
    }
    document.body.classList.remove('aur-no-scroll');
    qsa('.aur-mob-item.open').forEach(function (el) {
      el.classList.remove('open');
      var btn = qs('[aria-expanded]', el);
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  if (hamburger) hamburger.addEventListener('click', openMob);
  if (mobClose)  mobClose.addEventListener('click', closeMob);

  /* Only close drawer on actual navigation links, not sub-menu toggles */
  qsa('.aur-mob-sub-link').forEach(function (a) {
    a.addEventListener('click', closeMob);
  });
  qsa('.aur-mob-links .aur-mob-item > a.aur-mob-link').forEach(function (a) {
    a.addEventListener('click', closeMob);
  });

  window.aurToggleMobSub = function (btn) {
    var item   = btn.closest('.aur-mob-item');
    if (!item) return;
    var isOpen = item.classList.contains('open');

    qsa('.aur-mob-item.open').forEach(function (el) {
      if (el !== item) {
        el.classList.remove('open');
        var b = qs('[aria-expanded]', el);
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });

    if (isOpen) {
      item.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  };


  /* ================================================================
     6. SEARCH OVERLAY
     ================================================================ */
  var searchPanel    = qs('#aurSearchPanel');
  var searchBackdrop = qs('#aurSearchBackdrop');
  var searchInput    = qs('#aurSearchInput');

  function openSearch() {
    if (!searchPanel) return;
    updateHeaderHeight();
    searchPanel.classList.add('open');
    if (searchBackdrop) searchBackdrop.classList.add('open');
    document.body.classList.add('aur-no-scroll');
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 80);
  }

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.classList.remove('open');
    if (searchBackdrop) searchBackdrop.classList.remove('open');
    document.body.classList.remove('aur-no-scroll');
  }

  window.aurOpenSearch = openSearch;
  window.aurCloseSearch = closeSearch;
  window.aurClearSearch = function () {
    if (searchInput) { searchInput.value = ''; searchInput.focus(); }
  };

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.aur-open-search');
    if (!trigger) return;
    event.preventDefault();
    openSearch();
  });
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

  document.addEventListener('click', function (event) {
    if (!searchPanel || !searchPanel.classList.contains('open')) return;
    if (event.target.closest('#aurSearchPanel')) return;
    if (event.target.closest('.aur-open-search')) return;
    closeSearch();
  });

  if (searchInput) {
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var q = searchInput.value.trim();
        if (q) window.location.href = window.auroreSearchQuery.url(q);
      }
    });
  }

  qsa('.aur-chip[data-q]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      if (searchInput) { searchInput.value = chip.dataset.q; searchInput.focus(); }
    });
  });


  /* ================================================================
     7. CART DRAWER
     ================================================================ */
  var cartPanel = qs('#aurCartPanel');
  var overlay   = qs('#aurOverlay');
  var KLAVIYO_CART_LIST_ID = 'TvjSCp';
  var KLAVIYO_CART_PUB_KEY = 'XEAs57';
  var CART_DISCOUNT_COUPON = 'UNLOCK5';

  window.CJF = window.CJF || {
    panelState: 'email',
    submitting: false,
    wired: false
  };

  function validCartCaptureEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(email || '').toLowerCase());
  }

  function getKlaviyoCartItems(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return [];
    return cartData.items.map(function (item) {
      return {
        'SKU': item.sku || '',
        'Product Name': item.product_title || '',
        'Variant': (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '',
        'Quantity': item.quantity,
        'Unit Price': '$' + (item.price / 100).toFixed(2),
        'Line Total': '$' + (item.line_price / 100).toFixed(2),
        'Product URL': window.location.origin + (item.url || ''),
        'Image URL': item.image || ''
      };
    });
  }

  function setCartCapturePanel(state) {
    window.CJF.panelState = state || window.CJF.panelState || 'email';
    var formPanel = qs('#cjf-s1');
    var successPanel = qs('#cjf-s2');
    var showSuccess = window.CJF.panelState === 'success';
    if (formPanel) formPanel.hidden = showSuccess;
    if (successPanel) successPanel.hidden = !showSuccess;
  }

  function placeCartCapture() {
    var capture = qs('#cjf-strip');
    var shippingSlot = qs('#aurCartShippingEmailSlot');
    var shippingResults = qs('#aurCartRateResults');
    var desktopAnchor = qs('#aurCartEmailAnchor');
    var mobileAnchor = qs('#aurCartUpsell');
    var trustRow = qs('#aurCartTrustRow');
    var footer = qs('#aurCartFooter');
    if (!capture) return;
    if (window.matchMedia && window.matchMedia('(min-width: 900px)').matches && shippingSlot && shippingResults && !shippingResults.hidden) {
      shippingSlot.hidden = false;
      if (capture.parentNode !== shippingSlot) shippingSlot.appendChild(capture);
      if (trustRow && capture.parentNode && trustRow.previousElementSibling !== capture) capture.parentNode.insertBefore(trustRow, capture.nextSibling);
    } else if (window.matchMedia && window.matchMedia('(min-width: 900px)').matches && desktopAnchor) {
      if (shippingSlot) shippingSlot.hidden = true;
      if (capture.parentNode !== desktopAnchor) desktopAnchor.appendChild(capture);
      if (trustRow && capture.parentNode && trustRow.previousElementSibling !== capture) capture.parentNode.insertBefore(trustRow, capture.nextSibling);
    } else if (mobileAnchor && mobileAnchor.parentNode && capture.nextElementSibling !== mobileAnchor) {
      if (shippingSlot) shippingSlot.hidden = true;
      var mobileParent = mobileAnchor.parentNode;
      mobileParent.insertBefore(capture, mobileAnchor);
      if (trustRow && trustRow.parentNode !== mobileParent) mobileParent.insertBefore(trustRow, mobileAnchor);
    }
  }

  function initCartSummaryTabs() {
    qsa('[data-aur-summary-tab]').forEach(function (tab) {
      if (tab.dataset.aurTabReady === 'true') return;
      tab.dataset.aurTabReady = 'true';
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-aur-summary-tab');
        var root = tab.closest('[data-aur-summary-tabs]');
        if (!root || !target) return;
        qsa('[data-aur-summary-tab]', root).forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        qsa('[data-aur-summary-panel]', root).forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-aur-summary-panel') === target);
        });
        placeCartCapture();
      });
    });
  }

  function syncCartMobileEstimateState() {
    var panel = cartPanel || qs('#aurCartPanel');
    if (!panel) return;
    var isEstimated = !!cartEstimate.zip;
    panel.classList.toggle('aur-cart-estimate-complete', isEstimated);
    if (isEstimated) panel.classList.add('aur-cart-estimate-open');
    var toggle = qs('.aur-cp-mobile-estimate-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', panel.classList.contains('aur-cart-estimate-open') ? 'true' : 'false');
  }

  function initCartMobileEstimateToggle() {
    var toggle = qs('.aur-cp-mobile-estimate-toggle');
    if (!window.AuroreMobileEstimateToggleReady) {
      window.AuroreMobileEstimateToggleReady = true;
      document.addEventListener('click', function (event) {
        var clickedToggle = event.target.closest('[data-aur-mobile-estimate-toggle]');
        if (!clickedToggle) return;
        var panel = clickedToggle.closest('#aurCartPanel') || cartPanel || qs('#aurCartPanel');
        if (!panel) return;
        var opening = !panel.classList.contains('aur-cart-estimate-open');
        panel.classList.toggle('aur-cart-estimate-open', opening);
        clickedToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) {
          window.setTimeout(function () {
            var input = qs('#aurCartZipInput');
            if (input && window.matchMedia && window.matchMedia('(max-width: 767px)').matches) input.focus();
          }, 160);
        }
      });
    }
    if (!toggle) {
      syncCartMobileEstimateState();
      return;
    }
    if (toggle.dataset.aurReady !== 'true') {
      toggle.dataset.aurReady = 'true';
    }
    syncCartMobileEstimateState();
  }

  initCartMobileEstimateToggle();

  function cartCheckoutUrl() {
    if (!cartEstimate.zip) return '/checkout';
    var params = new URLSearchParams();
    params.set('checkout[shipping_address][country]', 'United States');
    params.set('checkout[shipping_address][country_code]', 'US');
    params.set('checkout[shipping_address][zip]', cartEstimate.zip);
    return '/checkout?' + params.toString();
  }

  function cartPriceHtml(originalCents, finalCents) {
    var original = typeof originalCents === 'number' ? originalCents : finalCents;
    var finalPrice = typeof finalCents === 'number' ? finalCents : original;
    if (original > finalPrice) {
      return '<s class="aur-price-old">' + money(original) + '</s><span class="aur-price-final">' + money(finalPrice) + '</span>';
    }
    return '<span class="aur-price-final">' + money(finalPrice) + '</span>';
  }

  function cartDiscountApplicationsHtml(applications) {
    if (!Array.isArray(applications) || !applications.length) return '';
    return applications.map(function (application) {
      var title = application.title || (application.discount_application && application.discount_application.title) || 'Discount';
      var amount = typeof application.total_allocated_amount === 'number'
        ? application.total_allocated_amount
        : (typeof application.amount === 'number' ? application.amount : null);
      return '<span>' + esc(title) + (amount !== null ? ' -' + money(amount) : '') + '</span>';
    }).join('');
  }

  function cartSavingsHtml(originalCents, finalCents) {
    if (!(originalCents > finalCents)) return '';
    var savings = originalCents - finalCents;
    var percent = originalCents > 0 ? Math.round((savings / originalCents) * 100) : 0;
    return '<span class="aur-ci-discounts">Save ' + (percent > 0 ? percent + '%' : money(savings)) + '</span>';
  }

  function updateCartEstimateTotals() {
    var hasEstimate = !!cartEstimate.zip;
    var tax = hasEstimate ? Math.round(cartEstimate.total * CART_ESTIMATE_TAX_RATE) : 0;
    var total = cartEstimate.total + (hasEstimate ? cartEstimate.selectedShipping : 0) + tax;
    var shippingText = hasEstimate ? (cartEstimate.selectedShipping > 0 ? money(cartEstimate.selectedShipping) : 'Free') : '$---';
    var taxText = hasEstimate ? money(tax) : '$---';
    var totalText = hasEstimate ? money(total) : cartPriceHtml(cartEstimate.originalTotal, cartEstimate.total);
    var shippingSummary = qs('#aurCartShippingSummary');
    var taxSummary = qs('#aurCartTaxSummary');
    var discountRow = qs('#aurCartDiscountRow');
    var discountSummary = qs('#aurCartDiscountSummary');
    var summaryTotal = qs('#aurCartSummaryTotal');
    var checkoutTotal = qs('#aurCheckoutTotal');
    var installmentAmount = qs('#aurShopPayInstallmentAmount');
    var note = qs('#aurCartEstimateNote');
    if (shippingSummary) {
      shippingSummary.textContent = shippingText;
      shippingSummary.classList.toggle('aur-cp-summary-value--success', hasEstimate && cartEstimate.selectedShipping <= 0);
    }
    if (taxSummary) taxSummary.textContent = taxText;
    if (discountRow) discountRow.hidden = !cartEstimate.cartLevelDiscountHtml;
    if (discountSummary) discountSummary.innerHTML = cartEstimate.cartLevelDiscountHtml || '';
    if (summaryTotal) summaryTotal.innerHTML = totalText;
    if (checkoutTotal) checkoutTotal.textContent = money(hasEstimate ? total : cartEstimate.total);
    if (installmentAmount) installmentAmount.textContent = money(Math.ceil((hasEstimate ? total : cartEstimate.total) / 4));
    if (note) note.textContent = hasEstimate ? 'Includes estimated tax and selected shipping for zip ' + cartEstimate.zip + '.' : '';
    qsa('.aur-checkout-btn').forEach(function (link) { link.href = cartCheckoutUrl(); });
  }

  function fallbackCartRates() {
    return [
      { name: 'Standard (4-7 days)', priceCents: 0 },
      { name: 'Express (2-3 days)', priceCents: 2495 },
      { name: 'Next Day', priceCents: 4995 }
    ];
  }

  function normalizeCartRates(rates) {
    return (Array.isArray(rates) ? rates : []).map(function (rate) {
      return {
        name: rate.name || rate.presentment_name || rate.service_name || 'Shipping',
        priceCents: parseMoneyToCents(rate.price || rate.presentment_price || 0)
      };
    }).filter(function (rate) { return rate.name; });
  }

  function renderCartRates(rates) {
    var list = qs('#aurCartRateList');
    var entry = qs('#aurCartZipEntry');
    var results = qs('#aurCartRateResults');
    var zipDisplay = qs('#aurCartZipDisplay');
    if (!list || !results || !entry) return;
    cartEstimate.rates = rates.length ? rates : fallbackCartRates();
    if (!cartEstimate.selectedRate) cartEstimate.selectedRate = cartEstimate.rates[0].name;
    var activeRate = cartEstimate.rates.find(function (rate) { return rate.name === cartEstimate.selectedRate; }) || cartEstimate.rates[0];
    cartEstimate.selectedRate = activeRate.name;
    cartEstimate.selectedShipping = activeRate.priceCents;
    list.innerHTML = cartEstimate.rates.map(function (rate) {
      var active = rate.name === cartEstimate.selectedRate;
      return '<button class="aur-cp-rate' + (active ? ' is-active' : '') + '" type="button" data-rate-name="' + esc(rate.name) + '" data-rate-price="' + rate.priceCents + '">'
        + '<span class="aur-cp-rate-left"><span class="aur-cp-rate-radio"></span><span>' + esc(rate.name) + '</span></span>'
        + '<span class="aur-cp-rate-price' + (rate.priceCents <= 0 ? ' is-free' : '') + '">' + (rate.priceCents > 0 ? money(rate.priceCents) : 'Free') + '</span>'
        + '</button>';
    }).join('');
    if (zipDisplay) zipDisplay.textContent = cartEstimate.zip;
    entry.hidden = true;
    results.hidden = false;
    var panel = cartPanel || qs('#aurCartPanel');
    if (panel) {
      panel.classList.add('aur-cart-estimate-open');
      panel.classList.add('aur-cart-estimate-complete');
    }
    syncCartMobileEstimateState();
    placeCartCapture();
    updateCartEstimateTotals();
  }

  function fetchCartRates(zip) {
    var query = 'shipping_address%5Bcountry%5D=United%20States&shipping_address%5Bzip%5D=' + encodeURIComponent(zip);
    return fetch('/cart/prepare_shipping_rates.json?' + query, { method: 'POST' })
      .then(function () {
        var tries = 0;
        function poll() {
          tries += 1;
          return fetch('/cart/async_shipping_rates.json?' + query)
            .then(function (response) { return response.ok ? response.json() : Promise.reject(response); })
            .then(function (data) {
              var rates = normalizeCartRates(data && data.shipping_rates);
              if (rates.length || tries >= 6) return rates;
              return new Promise(function (resolve) { setTimeout(resolve, 500); }).then(poll);
            });
        }
        return poll();
      });
  }

  function runCartShippingEstimate() {
    var input = qs('#aurCartZipInput');
    var button = qs('#aurCartEstimateBtn');
    var error = qs('#aurCartZipError');
    if (!input || !button) return;
    var zip = String(input.value || '').trim();
    if (!/^\d{5}$/.test(zip)) {
      if (error) {
        error.textContent = 'Enter a valid 5-digit zip code.';
        error.hidden = false;
      }
      input.focus();
      return;
    }
    if (error) error.hidden = true;
    cartEstimate.zip = zip;
    cartEstimate.selectedRate = null;
    button.disabled = true;
    button.textContent = 'Estimating';
    fetchCartRates(zip)
      .then(function (rates) { renderCartRates(rates); })
      .catch(function () { renderCartRates(fallbackCartRates()); })
      .finally(function () {
        button.disabled = false;
        button.textContent = 'Estimate';
      });
  }

  function resetCartShippingEstimate() {
    cartEstimate.zip = '';
    cartEstimate.selectedShipping = 0;
    cartEstimate.selectedRate = null;
    cartEstimate.rates = [];
    var entry = qs('#aurCartZipEntry');
    var results = qs('#aurCartRateResults');
    var input = qs('#aurCartZipInput');
    var error = qs('#aurCartZipError');
    if (entry) entry.hidden = false;
    if (results) results.hidden = true;
    var shippingSlot = qs('#aurCartShippingEmailSlot');
    if (shippingSlot) shippingSlot.hidden = true;
    if (input) input.value = '';
    if (error) error.hidden = true;
    var panel = cartPanel || qs('#aurCartPanel');
    if (panel) panel.classList.remove('aur-cart-estimate-complete');
    syncCartMobileEstimateState();
    placeCartCapture();
    updateCartEstimateTotals();
  }

  function initCartShippingEstimate() {
    var button = qs('#aurCartEstimateBtn');
    var input = qs('#aurCartZipInput');
    var change = qs('#aurCartZipChange');
    var list = qs('#aurCartRateList');
    if (button && button.dataset.aurReady !== 'true') {
      button.dataset.aurReady = 'true';
      button.addEventListener('click', runCartShippingEstimate);
    }
    if (input && input.dataset.aurReady !== 'true') {
      input.dataset.aurReady = 'true';
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          runCartShippingEstimate();
        }
      });
    }
    if (change && change.dataset.aurReady !== 'true') {
      change.dataset.aurReady = 'true';
      change.addEventListener('click', resetCartShippingEstimate);
    }
    if (list && list.dataset.aurReady !== 'true') {
      list.dataset.aurReady = 'true';
      list.addEventListener('click', function (event) {
        var rateButton = event.target.closest('.aur-cp-rate');
        if (!rateButton) return;
        cartEstimate.selectedRate = rateButton.dataset.rateName || '';
        cartEstimate.selectedShipping = parseInt(rateButton.dataset.ratePrice || '0', 10) || 0;
        qsa('.aur-cp-rate', list).forEach(function (item) {
          item.classList.toggle('is-active', item === rateButton);
        });
        updateCartEstimateTotals();
        var panelEl = cartPanel || qs('#aurCartPanel');
        if (panelEl && window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
          window.setTimeout(function () {
            panelEl.classList.remove('aur-cart-estimate-open');
            var tog = qs('.aur-cp-mobile-estimate-toggle');
            if (tog) tog.setAttribute('aria-expanded', 'false');
          }, 450);
        }
      });
    }
  }

  function subscribeCartCapture(email, cartData, callback) {
    var items = getKlaviyoCartItems(cartData);
    var cartTotal = cartData ? '$' + (cartData.total_price / 100).toFixed(2) : '';
    var cartValue = cartData ? parseFloat((cartData.total_price / 100).toFixed(2)) : 0;
    var itemCount = cartData ? cartData.item_count : 0;

    if (window._learnq && typeof window._learnq.push === 'function') {
      try {
        window._learnq.push(['identify', {
          '$email': email,
          'Cart Total': cartTotal,
          'Cart Item Count': itemCount,
          'Coupon Offered': CART_DISCOUNT_COUPON
        }]);
        window._learnq.push(['track', 'Cart Discount Signup', {
          '$email': email,
          '$value': cartValue,
          'Cart Total': cartTotal,
          'Item Count': itemCount,
          'Coupon': CART_DISCOUNT_COUPON,
          'Items': items
        }]);
      } catch (e) {}
    }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_CART_PUB_KEY), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    'Cart Total': cartTotal,
                    'Cart Item Count': itemCount,
                    'Coupon Offered': CART_DISCOUNT_COUPON,
                    'Items': items
                  }
                }
              }
            },
            custom_source: 'Cart Drawer'
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_CART_LIST_ID
              }
            }
          }
        }
      })
    })
      .then(function (response) { callback(response.ok || response.status === 202); })
      .catch(function () { callback(true); });
  }

  function submitCartCapture() {
    if (window.CJF.submitting) return;
    var input = qs('#cjf-email');
    var submit = qs('#cjf-submit');
    var error = qs('#cjf-err');
    var email = input ? input.value.trim() : '';

    if (!email) {
      if (error) error.textContent = 'Please enter your email.';
      return;
    }
    if (!validCartCaptureEmail(email)) {
      if (error) error.textContent = 'Please enter a valid email.';
      return;
    }

    if (error) error.textContent = '';
    window.CJF.submitting = true;
    if (submit) {
      submit.disabled = true;
      submit.textContent = '...';
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .catch(function () { return null; })
      .then(function (cartData) {
        subscribeCartCapture(email, cartData, function (ok) {
          window.CJF.submitting = false;
          if (submit) {
            submit.disabled = false;
            submit.innerHTML = '&#8594;';
          }
          if (ok) {
            setCartCapturePanel('success');
          } else if (error) {
            error.textContent = 'Something went wrong. Please try again.';
          }
        });
      });
  }

  function trackViewedCart(cartData) {
    if (!window._learnq || typeof window._learnq.push !== 'function') return;
    if (!cartData || !cartData.items || !cartData.items.length) return;
    var items = getKlaviyoCartItems(cartData);
    var total = '$' + (cartData.total_price / 100).toFixed(2);
    try {
      window._learnq.push(['track', 'Viewed Cart', {
        '$value': parseFloat((cartData.total_price / 100).toFixed(2)),
        'Cart Total': total,
        'Item Count': cartData.item_count,
        'Items': items,
        'Cart URL': window.location.origin + '/cart'
      }]);
      window._learnq.push(['identify', {
        'Last Cart Total': total,
        'Last Cart Item Count': cartData.item_count,
        'Last Cart Items': items
      }]);
    } catch (e) {}
  }

  document.addEventListener('click', function (event) {
    var submit = event.target.closest('#cjf-submit');
    if (submit) {
      event.preventDefault();
      event.stopPropagation();
      submitCartCapture();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Enter' || event.keyCode === 13) && event.target && event.target.id === 'cjf-email') {
      event.preventDefault();
      event.stopPropagation();
      submitCartCapture();
    }
  }, true);

  function openCart() {
    if (!cartPanel) return;
    cartPanel.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.classList.add('aur-no-scroll');
    switchDrawerTab('bag');
    fetchCart();
  }

  function closeCart() {
    if (!cartPanel) return;
    cartPanel.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.classList.remove('aur-no-scroll');
  }

  window.aurOpenCart  = openCart;
  window.aurCloseCart = closeCart;

  document.addEventListener('click', function (event) {
    var cartTrigger = event.target.closest('.aur-open-cart');
    if (!cartTrigger) return;
    event.preventDefault();
    openCart();
  });
  document.addEventListener('click', function (event) {
    var wishlistTrigger = event.target.closest('.aur-open-wishlist');
    if (!wishlistTrigger) return;
    event.preventDefault();
    openCart();
    switchDrawerTab('wishlist');
  });
  if (overlay) overlay.addEventListener('click', closeCart);

  function centsFromAny(value) {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return Math.round(value);
    var text = String(value).trim();
    if (!text) return 0;
    if (text.indexOf('.') !== -1) return Math.round(parseFloat(text) * 100);
    var digits = text.replace(/[^\d-]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function normalizeWishlistEntry(item) {
    if (item === null || item === undefined) return null;
    if (typeof item === 'string' || typeof item === 'number') return { id: String(item) };
    if (typeof item !== 'object' || !item.id) return null;
    return {
      id: String(item.id),
      title: item.title || '',
      url: item.url || '',
      handle: item.handle || '',
      image: item.image || '',
      price: centsFromAny(item.price),
      compareAtPrice: centsFromAny(item.compareAtPrice),
      variantId: item.variantId ? String(item.variantId) : '',
      variantTitle: item.variantTitle || '',
      type: item.type || '',
      autoDiscountPercent: item.autoDiscountPercent || 0
    };
  }

  function wishlistEntries() {
    try {
      var raw = JSON.parse(localStorage.getItem('aurore_wishlist_ids') || '[]');
      if (!Array.isArray(raw)) return [];
      var map = {};
      raw.map(normalizeWishlistEntry).filter(Boolean).forEach(function (entry) {
        map[entry.id] = Object.assign({}, map[entry.id] || { id: entry.id }, entry);
      });
      return Object.keys(map).map(function (id) { return map[id]; });
    } catch (e) {
      return [];
    }
  }

  function wishlistIds() {
    return wishlistEntries().map(function (entry) { return entry.id; });
  }

  function wishlistCatalog() {
    var node = qs('#aurCartRecommendationData');
    if (!node) return [];
    try {
      var products = JSON.parse(node.textContent || '[]');
      return Array.isArray(products) ? products.map(expandCartRecommendationProduct).filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function wishlistProductMap() {
    var map = {};
    wishlistCatalog().forEach(function (product) {
      if (product && product.id) map[String(product.id)] = product;
    });
    return map;
  }

  var wishlistLiveCatalogPromise;

  function normalizeWishlistLiveProduct(product) {
    if (!product || !product.id) return null;
    var variant = product.variants && product.variants[0] ? product.variants[0] : null;
    var image = product.images && product.images[0] ? product.images[0] : '';
    return {
      id: product.id,
      title: product.title || '',
      type: product.product_type || product.type || '',
      url: '/products/' + (product.handle || ''),
      handle: product.handle || '',
      image: image && image.src ? image.src : image,
      price: variant ? centsFromAny(variant.price) : centsFromAny(product.price || 0),
      compareAtPrice: variant ? centsFromAny(variant.compare_at_price) : centsFromAny(product.compare_at_price || 0),
      variantId: variant ? variant.id : '',
      variantTitle: variant ? variant.title : '',
      autoDiscountPercent: 0
    };
  }

  function fetchWishlistLiveCatalog() {
    if (wishlistLiveCatalogPromise) return wishlistLiveCatalogPromise;
    function fetchPagedCatalog(baseUrl, maxPages) {
      var tasks = [];
      for (var page = 1; page <= maxPages; page += 1) {
        var url = baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'limit=250&page=' + page;
        tasks.push(
          fetch(url, { headers: { 'Accept': 'application/json' } })
            .then(function (response) { return response.ok ? response.json() : { products: [] }; })
            .catch(function () { return { products: [] }; })
        );
      }
      return Promise.all(tasks);
    }

    wishlistLiveCatalogPromise = Promise.all([
      fetchPagedCatalog('/collections/all-jewelry/products.json', 3),
      fetchPagedCatalog('/products.json', 4)
    ])
      .then(function (payloads) {
        var merged = {};
        payloads.forEach(function (pages) {
          (pages || []).forEach(function (data) {
            var products = data && Array.isArray(data.products) ? data.products : [];
            products.map(normalizeWishlistLiveProduct).filter(Boolean).forEach(function (product) {
              merged[String(product.id)] = product;
            });
          });
        });
        return Object.keys(merged).map(function (id) { return merged[id]; });
      })
      .catch(function () {
        return [];
      });
    return wishlistLiveCatalogPromise;
  }

  function renderWishlistDrawerState(target, products) {
    if (!target) return;
    if (!products.length) {
      target.innerHTML = '<div class="aur-wishlist-empty">'
        + '<p class="aur-wishlist-empty-title">Your wishlist is empty.</p>'
        + '<p class="aur-wishlist-empty-sub">Save pieces you love and come back to them here.</p>'
        + '<a class="aur-wishlist-empty-link" href="/collections/all-jewelry">Continue shopping</a>'
        + '</div>';
      return;
    }

    target.innerHTML = products.map(function (product) {
      var variantId = product.variantId || '';
      var meta = product.type || '';
      var variantTitle = product.variantTitle && product.variantTitle !== 'Default Title' ? product.variantTitle : '';
      var pricing = wishlistPricing(product);
      return '<div class="aur-wishlist-item" data-product-id="' + esc(String(product.id)) + '">'
        + '<a class="aur-wishlist-img" href="' + esc(product.url || ('/products/' + product.handle)) + '">'
        + (product.image ? '<img src="' + esc(product.image) + '" alt="' + esc(product.title || '') + '" loading="lazy">' : '')
        + '</a>'
        + '<div class="aur-wishlist-info">'
        + '<a class="aur-wishlist-name" href="' + esc(product.url || ('/products/' + product.handle)) + '">' + esc(product.title || '') + '</a>'
        + (meta ? '<div class="aur-wishlist-meta">' + esc(meta) + '</div>' : '')
        + (variantTitle ? '<div class="aur-wishlist-meta">' + esc(variantTitle) + '</div>' : '')
        + '<div class="aur-wishlist-price-row">'
        + '<span class="aur-wishlist-price">' + money(pricing.finalPrice || 0) + '</span>'
        + wishlistSaveHtml(pricing)
        + '</div>'
        + '</div>'
        + '<div class="aur-wishlist-actions">'
        + '<button class="aur-wishlist-add" type="button" data-variant-id="' + esc(String(variantId)) + '">Add to Bag</button>'
        + '<button class="aur-wishlist-remove" type="button" data-product-id="' + esc(String(product.id)) + '">Remove</button>'
        + '</div>'
        + '</div>';
    }).join('');
  }

  function salePriceHtml(price) {
    var percent = Number(window.auroreStorefrontSalePercent) || 0;
    if (!percent) return money(price);
    return '<span class="aur-sale-prices"><span class="aur-sale-current">' + money(price - Math.round(price * percent / 100)) + '</span><s class="aur-sale-original">' + money(price) + '</s></span>';
  }

  function wishlistPricing(product) {
    var price = parseInt(product && product.price || 0, 10) || 0;
    var compareAtPrice = parseInt(product && product.compareAtPrice || 0, 10) || 0;
    var autoDiscountPercent = Number(window.auroreStorefrontSalePercent) || parseFloat(product && product.autoDiscountPercent || 0) || 0;
    if (autoDiscountPercent > 0 && price > 0) {
      return {
        finalPrice: Math.round(price * (100 - autoDiscountPercent) / 100),
        oldPrice: price,
        savePercent: Math.round(autoDiscountPercent)
      };
    }
    if (compareAtPrice > price && price > 0) {
      return {
        finalPrice: price,
        oldPrice: compareAtPrice,
        savePercent: Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
      };
    }
    return {
      finalPrice: price,
      oldPrice: 0,
      savePercent: 0
    };
  }

  function wishlistSaveHtml(pricing) {
    if (!pricing || !pricing.oldPrice || !pricing.savePercent) return '';
    return '<span class="aur-wishlist-old-price">' + money(pricing.oldPrice) + '</span>'
      + '<span class="aur-wishlist-save">Save ' + pricing.savePercent + '%</span>';
  }

  function renderWishlistDrawer() {
    var target = qs('#aurWishlistItems');
    if (!target) return;

    var entries = wishlistEntries();
    var ids = entries.map(function (entry) { return entry.id; });
    if (!ids.length) {
      renderWishlistDrawerState(target, []);
      return;
    }

    target.innerHTML = '<div class="aur-wishlist-empty"><p class="aur-wishlist-empty-sub">Loading your saved items...</p></div>';

    var baseMap = wishlistProductMap();
    var storedMap = {};
    entries.forEach(function (entry) {
      storedMap[entry.id] = entry;
    });
    var missingIds = ids.filter(function (id) { return !storedMap[id] && !baseMap[id]; });

    function finalizeRender(liveProducts) {
      var map = {};
      Object.keys(storedMap).forEach(function (id) {
        map[id] = storedMap[id];
      });
      Object.keys(baseMap).forEach(function (id) {
        map[id] = Object.assign({}, map[id] || {}, baseMap[id]);
      });
      (liveProducts || []).forEach(function (product) {
        if (product && product.id) map[String(product.id)] = Object.assign({}, map[String(product.id)] || {}, product);
      });
      var products = ids
        .map(function (id) { return map[id]; })
        .filter(function (product) {
          return product && product.id && product.title && product.url;
        });
      renderWishlistDrawerState(target, products);
    }

    if (!missingIds.length) {
      finalizeRender([]);
      return;
    }

    fetchWishlistLiveCatalog().then(function (liveCatalog) {
      finalizeRender(liveCatalog.filter(function (product) {
        return missingIds.indexOf(String(product.id)) !== -1;
      }));
    });
  }

  function refreshWishlistCount() {
    var count = wishlistIds().length;
    qsa('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function switchDrawerTab(tab) {
    if (!cartPanel) return;
    var isWishlist = tab === 'wishlist';
    cartPanel.dataset.activeTab = isWishlist ? 'wishlist' : 'bag';
    qsa('[data-aur-drawer-tab]').forEach(function (button) {
      var active = button.dataset.aurDrawerTab === (isWishlist ? 'wishlist' : 'bag');
      button.classList.toggle('aur-cp-tab--active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    var cartItems = qs('#aurCartItems');
    var wishlistItems = qs('#aurWishlistItems');
    var footer = qs('#aurCartFooter');
    if (cartItems) cartItems.hidden = isWishlist;
    if (wishlistItems) wishlistItems.hidden = !isWishlist;
    if (footer) footer.hidden = !isWishlist && (!aurLastCart || aurLastCart.item_count === 0);
    if (isWishlist) renderWishlistDrawer();
  }

  window.aurOpenWishlist = function () {
    openCart();
    switchDrawerTab('wishlist');
  };

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-aur-drawer-tab]');
    if (!tab) return;
    switchDrawerTab(tab.dataset.aurDrawerTab || 'bag');
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('.aur-wishlist-remove');
    if (!remove) return;
    var id = String(remove.dataset.productId || '');
    if (!id) return;
    var entries = wishlistEntries().filter(function (entry) { return entry.id !== id; });
    try { localStorage.setItem('aurore_wishlist_ids', JSON.stringify(entries)); } catch (e) {}
    refreshWishlistCount();
    renderWishlistDrawer();
    document.dispatchEvent(new CustomEvent('aurore:wishlist:changed', { detail: { ids: entries.map(function (entry) { return entry.id; }), entries: entries } }));
  });

  document.addEventListener('click', function (event) {
    var add = event.target.closest('.aur-wishlist-add');
    if (!add) return;
    var variantId = add.dataset.variantId;
    if (!variantId) return;
    add.disabled = true;
    add.textContent = 'Adding...';
    window.aurAddToCart(variantId, 1, function () {
      add.disabled = false;
      add.textContent = 'Added';
      setTimeout(function () { add.textContent = 'Add to Bag'; }, 1200);
      switchDrawerTab('bag');
    });
  });

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (e) { console.error('[Aurore] cart fetch:', e); });
  }

  function renderCart(cart) {
    aurLastCart = cart;
    var bubble = qs('#aurCartCount');
    if (bubble) {
      bubble.textContent = cart.item_count;
      bubble.style.display = cart.item_count === 0 ? 'none' : 'flex';
      bubble.classList.add('bump');
      setTimeout(function () { bubble.classList.remove('bump'); }, 350);
    }

    var countEl = qs('#aurCpCount');
    if (countEl) {
      countEl.textContent = '(' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ')';
      countEl.hidden = cart.item_count === 0;
    }
    var titleText = qs('#aurCpTitleText');
    if (titleText) {
      titleText.textContent = cart.item_count === 0 ? 'Your Bag' : 'Your Cart';
    }

    var thEl      = qs('#aurFreeShipping');
    var threshold = thEl ? parseInt(thEl.dataset.threshold, 10) : 15000;
    var shipFill  = qs('#aurShipFill');
    var shipText  = qs('#aurShipText');
    var shipWrap  = qs('#aurCartShip');
    if (shipWrap) shipWrap.hidden = cart.item_count === 0;
    if (shipFill && shipText) {
      var rem = threshold - cart.total_price;
      if (rem <= 0) {
        shipText.innerHTML = '🎉 You\'ve unlocked <strong>free shipping!</strong>';
        shipFill.style.width = '100%';
      } else {
        shipText.innerHTML = 'You\'re <strong>' + money(rem) + '</strong> away from free shipping';
        shipFill.style.width = Math.min(100, Math.round((cart.total_price / threshold) * 100)) + '%';
      }
    }

    var sub = qs('#aurCartSubtotal');
    var originalTotal = typeof cart.original_total_price === 'number' ? cart.original_total_price : cart.total_price;
    if (sub) sub.innerHTML = cartPriceHtml(originalTotal, cart.total_price);
    cartEstimate.subtotal = cart.total_price || 0;
    cartEstimate.originalTotal = originalTotal || cart.total_price || 0;
    cartEstimate.total = cart.total_price || 0;
    cartEstimate.cartLevelDiscountHtml = cartDiscountApplicationsHtml(cart.cart_level_discount_applications);
    initCartSummaryTabs();
    initCartShippingEstimate();
    initCartMobileEstimateToggle();
    placeCartCapture();
    updateCartEstimateTotals();

    var body = qs('#aurCartBody');
    var itemsTarget = qs('#aurCartItems') || body;
    if (!body || !itemsTarget) return;
    var footer = qs('#aurCartFooter');
    var capture = qs('#cjf-strip');
    if (capture) capture.hidden = cart.item_count === 0;
    setCartCapturePanel();
    if (cartPanel && cartPanel.classList.contains('open')) trackViewedCart(cart);

    if (cart.item_count === 0) {
      var emptyTemplate = qs('#aurEmptyCartTemplate');
      itemsTarget.innerHTML = emptyTemplate ? emptyTemplate.innerHTML : '<div class="aur-cp-empty"><p class="aur-cp-empty-title">Your bag is empty</p><p class="aur-cp-empty-sub">Start building your collection.</p></div>';
      if (footer) footer.hidden = !(cartPanel && cartPanel.dataset.activeTab === 'wishlist');
      renderCartRecommendations(cart);
      renderEmptyRecentlyViewed();
      return;
    }

    if (footer) footer.hidden = false;

    itemsTarget.innerHTML = cart.items.map(function (item) {
      if (window.AuroreCertificate && window.AuroreCertificate.isCertificate(item) && item.parent_relationship) return '';
      var imgSrc = '';
      if (item.featured_image && item.featured_image.url) {
        imgSrc = item.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2');
      }
      var varHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="aur-ci-variant">' + esc(item.variant_title) + '</div>' : '';
      var propHtml = '';
      var shippingPropHtml = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          var html = cartPropertyHtml(key, item.properties[key]);
          if (!html) return;
          if (isShippingCartProperty(key)) {
            shippingPropHtml += html;
          } else {
            propHtml += html;
          }
        });
      }
      propHtml += shippingPropHtml;
      var originalLinePrice = typeof item.original_line_price === 'number' ? item.original_line_price : item.line_price;
      var finalLinePrice = typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
      if (window.AuroreCertificate) finalLinePrice = window.AuroreCertificate.chargedLinePrice(item);
      var lineDiscountHtml = '';
      var imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + esc(item.product_title) + '" loading="lazy"/>' : '';

      return '<div class="aur-ci" data-key="' + item.key + '">'
        + '<a href="' + item.url + '" class="aur-ci-img">' + imgHtml + '</a>'
        + '<div class="aur-ci-body">'
        + '<div class="aur-ci-name">' + esc(item.product_title) + '</div>'
        + varHtml
        + propHtml
        + (window.AuroreCertificate ? window.AuroreCertificate.optionHtml(item, cart) : '')
        + '<div class="aur-ci-actions">'
        + '<button class="aur-ci-rm" onclick="aurQty(\'' + item.key + '\',0)">Remove</button>'
        + '<div class="aur-qty">'
        + '<button class="aur-qty-btn" onclick="aurQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease">−</button>'
        + '<span class="aur-qty-n">' + item.quantity + '</span>'
        + '<button class="aur-qty-btn" onclick="aurQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Increase">+</button>'
        + '</div></div>'
        + '<span class="aur-ci-price">' + cartPriceHtml(originalLinePrice, finalLinePrice) + lineDiscountHtml + '</span>'
        + '</div></div>';
    }).join('');

    renderCartRecommendations(cart);
  }

  function renderEmptyRecentlyViewed() {
    var section = qs('[data-aur-empty-recent]');
    var row = qs('[data-aur-empty-recent-row]');
    if (!section || !row) return;

    try {
      var stored = JSON.parse(localStorage.getItem('aurore_recently_viewed') || '[]');
      if (!Array.isArray(stored)) stored = [];
      var products = stored.filter(function (product) {
        return product && product.title && product.url && product.image;
      }).slice(0, 4);

      if (!products.length) {
        row.innerHTML = '';
        section.hidden = true;
        return;
      }

      row.innerHTML = products.map(function (product) {
        return '<article class="aur-empty-product-card aur-empty-recent-card">'
          + '<a class="aur-empty-product-img aur-empty-recent-img" href="' + esc(product.url) + '">'
          + '<img src="' + esc(product.image) + '" alt="' + esc(product.title) + '" loading="lazy">'
          + '</a>'
          + '<div class="aur-empty-product-info">'
          + '<a class="aur-empty-product-name aur-empty-recent-name" href="' + esc(product.url) + '">' + esc(product.title) + '</a>'
          + (product.price ? '<div class="aur-empty-product-price aur-empty-recent-price">' + esc(product.price) + '</div>' : '')
          + '</div>'
          + '</article>';
      }).join('');
      section.hidden = false;
    } catch (e) {
      row.innerHTML = '';
      section.hidden = true;
    }
  }

  function renderCartRecommendations(cart) {
    var wrap = qs('#aurCartUpsell');
    var list = qs('#aurCartUpsellList');
    if (!wrap || !list) return;

    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var first = items[0];
    if (!first || !first.product_id) {
      wrap.hidden = true;
      list.innerHTML = '';
      return;
    }

    var cartProductIds = items.map(function (item) { return item.product_id; });

    function upsellActionHtml(variantId, url) {
      if (variantId) {
        return '<button class="aur-cp-upsell-add" type="button" data-variant-id="' + esc(String(variantId)) + '">+ Add</button>';
      }
      return '<a class="aur-cp-upsell-add" href="' + esc(url || '/collections/all-jewelry') + '">Choose</a>';
    }

    var styleProducts = buildCartStyleRecommendations(cart, 3);
    if (styleProducts.length) {
      list.innerHTML = styleProducts.map(function (product) {
        var variantId = product.variantId || '';
        var productUrl = product.url || ('/products/' + product.handle);
        return '<div class="aur-cp-upsell-item">'
          + '<a class="aur-cp-upsell-img" href="' + esc(productUrl) + '">'
          + (product.image ? '<img src="' + esc(product.image) + '" alt="' + esc(product.title || '') + '" loading="lazy">' : '')
          + '</a>'
          + '<div class="aur-cp-upsell-info">'
          + '<div class="aur-cp-upsell-name">' + esc(product.title || '') + '</div>'
          + '<div class="aur-cp-upsell-price">' + salePriceHtml(product.price || 0) + '</div>'
          + '</div>'
          + upsellActionHtml(variantId, productUrl)
          + '</div>';
      }).join('');
      wrap.hidden = false;
      return;
    }

    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(first.product_id) + '&limit=6&intent=related')
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (data) {
        var products = (data && data.products ? data.products : []).filter(function (product) {
          var currentType = normalizeCartRecTag(first.product_type);
          var productType = normalizeCartRecTag(product.product_type || product.type);
          return product
            && cartProductIds.indexOf(product.id) === -1
            && (!currentType || !productType || productType !== currentType);
        }).slice(0, 3);

        if (!products.length) {
          wrap.hidden = true;
          list.innerHTML = '';
          return;
        }

        list.innerHTML = products.map(function (product) {
          var variant = product.variants && product.variants[0] ? product.variants[0] : null;
          var image = product.featured_image || (product.images && product.images[0]) || '';
          var imageSrc = typeof image === 'string' ? image : (image && image.src ? image.src : '');
          var price = product.price || (variant && variant.price) || 0;
          var variantId = variant ? variant.id : '';
          var productUrl = '/products/' + (product.handle || '');
          return '<div class="aur-cp-upsell-item">'
            + '<a class="aur-cp-upsell-img" href="' + esc(productUrl) + '">'
            + (imageSrc ? '<img src="' + esc(imageSrc) + '" alt="' + esc(product.title || '') + '" loading="lazy">' : '')
            + '</a>'
            + '<div class="aur-cp-upsell-info">'
            + '<div class="aur-cp-upsell-name">' + esc(product.title || '') + '</div>'
            + '<div class="aur-cp-upsell-price">' + salePriceHtml(price) + '</div>'
            + '</div>'
            + upsellActionHtml(variantId, productUrl)
            + '</div>';
        }).join('');
        wrap.hidden = false;
      })
      .catch(function () {
        wrap.hidden = true;
        list.innerHTML = '';
      });
  }

  window.aurQty = function (key, qty) {
    if (window.AuroreCertificate) {
      window.AuroreCertificate.changeQuantity(key, qty).then(function (cart) {
        renderCart(cart);
        aurShowToast('✓', qty === 0 ? 'Item removed' : 'Cart updated');
      }).catch(function (error) { fetchCart(); aurShowToast('!', error.message); });
      return;
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (c) {
      renderCart(c);
      aurShowToast('✓', qty === 0 ? 'Item removed' : 'Cart updated');
    })
    .catch(function (e) { console.error('[Aurore] qty change:', e); });
  };

  document.addEventListener('aurore:certificate-updated', function (event) { renderCart(event.detail); });

  window.aurAddToCart = function (variantId, qty, cb) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      fetchCart();
      aurShowToast('✓', 'Added to your cart');
      openCart();
      if (typeof cb === 'function') cb();
    })
    .catch(function (e) { console.error('[Aurore] add to cart:', e); });
  };

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.aur-cp-upsell-add');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    event.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Adding...';
    window.aurAddToCart(variantId, 1, function () {
      btn.classList.add('added');
      btn.textContent = 'Added';
      btn.disabled = false;
    });
  });

  /* Initial cart count on page load */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (c) {
      var b = qs('#aurCartCount');
      if (b) { b.textContent = c.item_count; b.style.display = c.item_count === 0 ? 'none' : 'flex'; }
    })
    .catch(function () {});

  refreshWishlistCount();
  document.addEventListener('aurore:wishlist:changed', refreshWishlistCount);
  document.addEventListener('aurore:wishlist:changed', function () {
    if (cartPanel && cartPanel.dataset.activeTab === 'wishlist') renderWishlistDrawer();
  });


  /* ================================================================
     8. TOAST
     ================================================================ */
  var toastTimer;
  function toast(icon, msg) {
    clearTimeout(toastTimer);
    var el = qs('#aurToast');
    if (!el) return;
    var i = qs('#aurToastIcon'); if (i) i.textContent = icon || '✓';
    var m = qs('#aurToastMsg');  if (m) m.textContent  = msg  || '';
    el.classList.add('show');
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2800);
  }
  window.aurShowToast = toast;


  /* ================================================================
     9. ESC KEY — close all panels
     ================================================================ */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeSearch();
    closeMob();
    closeCart();
    qsa('.aur-mega.is-open').forEach(function (m) { m.classList.remove('is-open'); });
  });


  /* ================================================================
     10. SHOPIFY SECTION:LOAD — re-init after theme editor reload
     ================================================================ */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId && e.detail.sectionId.indexOf('header') !== -1) {
      updateHeaderHeight();
    }
  });

})();
